module.exports = __webpack_public_path__ + "img/mylender@2x.f0a7c2d.png";